import React from "react";

import mets from '../../assets/mets.jpeg'; // Tell webpack this JS file uses this image


import "./About.css";

export const About = () => {
  return <div className="aboutcontainer">
        <div className="about">
            <img src={mets} alt="Logo" className="pic"/>
            <p>Meevärk OÜ on 2020 aastal asutatud mesindusettevõte Lääne-Virumaal.</p>
        </div>
    </div>;
};